import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Loader from "../../common/loader";
import {
  addCategory,
  addService,
  deleteService,
  fetchCategories,
  fetchServices,
  updateCategory,
} from "../../redux/adminReducer";
import Modal from "../../common/modal";
import { toast } from "react-toastify";
import { IoEyeOutline } from "react-icons/io5";
function Services() {
  const navigate = useNavigate();
  const { translations, dir } = useSelector((state) => state.language);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryDesc, setNewCategoryDesc] = useState("");
  const [newCategoryPic, setNewCategoryPic] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [categoryToUpdate, setCategoryToUpdate] = useState(null);
  const dispatch = useDispatch();

  const categories = useSelector(
    (state) => state.admin.categories?.data?.category || []
  );
  const totalCategoryData = useSelector(
    (state) => state.admin.categories?.data?.totalData || 0
  );

  useEffect(() => {
    setLoading(true);
    dispatch(fetchCategories(currentPage)).then(() => {
      setLoading(false);
    });
  }, [dispatch, currentPage]);

  const handleDeleteClick = (service) => {
    setServiceToDelete(service);
    setIsModalOpen(true);
  };

  const handleRowClick = (categoryId) => {
    navigate(`/services/services-details/${categoryId}`);
  };

  const handleUpdateClick = (category) => {
    setCategoryToUpdate(category);
    setNewCategoryName(category.category_name);
    setNewCategoryDesc(category.category_desc);
    setIsUpdateModalOpen(true);
  };

  const handleAddService = () => {
    if (newCategoryName) {
      setLoading(true);
      const formData = new FormData();
      formData.append("category_name", newCategoryName);
      if (newCategoryDesc) formData.append("category_desc", newCategoryDesc);
      if (newCategoryPic) formData.append("category_pic", newCategoryPic);
      dispatch(addCategory(formData))
        .then(() => {
          dispatch(fetchCategories(currentPage));
          setLoading(false);
          toast.success("Category Added Successfully");
        })
        .catch((error) => {
          console.error("Not added", error);
          setLoading(false);
        })
        .finally(() => {
          setIsAddModalOpen(false);
          setNewCategoryName("");
        });
    }
  };

  const handleUpdateService = () => {
    if (!categoryToUpdate) return;
    const formData = new FormData();
    formData.append("id", categoryToUpdate._id);
    if (newCategoryName.trim())
      formData.append("category_name", newCategoryName.trim());
    if (newCategoryDesc.trim())
      formData.append("category_desc", newCategoryDesc.trim());
    if (newCategoryPic) formData.append("category_pic", newCategoryPic);
    setLoading(true);
    dispatch(updateCategory(formData))
      .then(() => {
        dispatch(fetchCategories(currentPage));
        toast.success("Category Updated Successfully");
      })
      .catch((err) => {
        console.error("Update failed", err);
      })
      .finally(() => {
        setLoading(false);
        setIsUpdateModalOpen(false);
        setNewCategoryName("");
        setCategoryToUpdate(null);
      });
  };

  const confirmDelete = () => {
    if (serviceToDelete) {
      setLoading(true);
      dispatch(deleteService({ id: serviceToDelete._id }))
        .then(() => {
          dispatch(fetchServices(currentPage));
          toast.success("Category deleted Successfully");
        })
        .catch((error) => {
          console.error("Delete failed", error);
        })
        .finally(() => {
          setLoading(false);
          setIsModalOpen(false);
          setServiceToDelete(null);
        });
    }
  };

  const BASE_URL = process.env.REACT_APP_BASE_URL || "https://jeema.co/api/v2/";

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalCategoryData / itemsPerPage);
  return (
    <>
      <Layout>
        <div className="min-h-screen w-full  px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.category.categories}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.category.categoriesManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.category.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300 ">
                  {translations.category.categories}
                </span>
              </div>
            </div>
          </section>
          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-2xl font-semibold text-white">
                    Category List
                  </h2>
                  <button
                    onClick={() => setIsAddModalOpen(true)}
                    className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
                  >
                    {translations.category.addCategory}
                  </button>
                </div>
                {categories.length === 0 ? (
                  <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
                    <p className="text-xl">
                      {translations.salon_request.noData}
                    </p>
                  </div>
                ) : (
                  <div className="grid  md:grid lg:grid  overflow-x-auto ">
                    <table className="min-w-full divide-y divide-gray-600 text-white">
                      <thead className="bg-[#5A189A] text-center">
                        <tr>
                          <th className="px-4 py-2 ">
                            {translations.category.categoryPic}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.category.categoryName}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.category.description}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.category.actions}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {categories.map((cat, index) => (
                          <tr key={index} className=" text-center">
                            <td className="px-4 py-2 flex justify-center">
                              <img
                                src={`${BASE_URL}${encodeURIComponent(
                                  cat.category_pic
                                )}`}
                                alt={`registration_document_${index}`}
                                className="h-10 w-10 object-cover rounded-lg"
                              />
                            </td>
                            <td className="px-4 py-2">{cat.category_name}</td>
                            <td className="px-4 py-2">{cat.category_desc}</td>
                            <td className="px-4 py-3 flex justify-center">
                              <button
                                onClick={() => handleUpdateClick(cat)}
                                className="text-green-600 hover:text-green-300 px-2 pt-1 text-xl"
                              >
                                <FaRegEdit />
                              </button>
                              <button
                                className="hover:text-green-600  px-2 pt-1 text-xl"
                                onClick={() => handleRowClick(cat._id)}
                              >
                                <IoEyeOutline />
                              </button>
                              {/* <button
                              // onClick={() => handleDeleteClick(service)}
                              className="text-red-700  hover:text-red-500 pt-3 text-2xl"
                            >
                              <MdDelete />
                            </button> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* Pagination Controls */}
                    <div className="mt-4 flex justify-between text-white">
                      <svg
                        className={`${
                          currentPage === 1
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        width={24}
                        height={24}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        aria-disabled={currentPage === 1}
                      >
                        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                      </svg>
                      <span>
                        {translations.salon_request.page}
                        {totalPages > 1 ? (
                          <input
                            type="number"
                            name=""
                            id="pagination-jump"
                            className={
                              error
                                ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                                : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                            }
                            min={1}
                            max={totalPages}
                            defaultValue={currentPage}
                            onChange={(e) => e.target.value}
                            onBlur={(e) => handlePageChange(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handlePageChange(e);
                              }
                            }}
                          />
                        ) : (
                          <span className="mx-1">{currentPage}</span>
                        )}
                        {translations.salon_request.of} {totalPages}
                      </span>
                      <svg
                        className={`${
                          currentPage === totalPages
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 320 512"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        aria-disabled={currentPage === totalPages}
                      >
                        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                      </svg>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>
      {/* delete modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="w-[90%] max-w-md"
      >
        <div className="text-white p-6  max-w-sm w-full">
          <h2 className="text-xl font-semibold mb-4 text-red-600">
            {translations.service.confirmDelete}
          </h2>
          <p className="mb-6">
            {translations.service.warning}{" "}
            <strong>{serviceToDelete?.service_name}</strong>{" "}
            {translations.service.service}
          </p>
          <div className="flex justify-end gap-3">
            <button
              className="bg-gray-500 px-4 py-2 rounded hover:bg-gray-400"
              onClick={() => setIsModalOpen(false)}
            >
              {translations.service.cancel}
            </button>
            <button
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              // onClick={() => {
              //   confirmDelete();
              //   setIsModalOpen(false);
              //   }}
            >
              {translations.service.delete}
            </button>
          </div>
        </div>
      </Modal>

      {/* category add modal */}
      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[50%] max-w-2xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 mx-auto">
          <h3 className="text-xl text-center text-white mb-6">
            Add New Category
          </h3>

          {/* Category Name */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.category.categoryName}
          </label>
          <input
            type="text"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          />

          {/* Category Description */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.category.categoryDescription}
          </label>
          <textarea
            value={newCategoryDesc}
            onChange={(e) => setNewCategoryDesc(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-1 resize-none"
          />

          {/* Warning message if less than 50 characters */}
          {newCategoryDesc.length > 0 && newCategoryDesc.length < 50 && (
            <p className="text-sm text-yellow-400 mb-3">
              {translations.category.descriptionmustbeatleastcharacters}
            </p>
          )}

          {/* Category Picture */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.category.categoryPicture}
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setNewCategoryPic(e.target.files?.[0] || null)}
            className="w-full text-white mb-3"
          />

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setIsAddModalOpen(false);
                setNewCategoryName("");
                setNewCategoryDesc("");
                setNewCategoryPic(null);
              }}
              className="w-full sm:w-auto px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
            >
              {translations.category.cancel}
            </button>
            <button
              onClick={handleAddService}
              disabled={newCategoryDesc.length < 50}
              className={`w-full sm:w-auto px-4 py-2 rounded text-white ${
                newCategoryDesc.length < 50
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {translations.category.submit}
            </button>
          </div>
        </div>
      </Modal>

      {/* category update modal */}
      <Modal
        isOpen={isUpdateModalOpen}
        onClose={() => setIsUpdateModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[50%] max-w-2xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 mx-auto">
          <h3 className="text-xl text-center mb-6 text-white">
            {translations.category.updateCategory}
          </h3>

          {/* Category Name */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.category.categoryName}
          </label>
          <input
            type="text"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          />

          {/* Category Description */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.category.description}
          </label>
          <textarea
            value={newCategoryDesc}
            onChange={(e) => setNewCategoryDesc(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-1 resize-none"
          />

          {/* Description Warning */}
          {newCategoryDesc.length > 0 && newCategoryDesc.length < 50 && (
            <p className="text-sm text-yellow-400 mb-3">
              {translations.category.descriptionmustbeatleastcharacters}
            </p>
          )}

          {/* Category Picture */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.category.categoryPicture}
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setNewCategoryPic(e.target.files?.[0] || null)}
            className="w-full text-white mb-3"
          />

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setIsUpdateModalOpen(false);
                setNewCategoryName("");
                setNewCategoryDesc("");
                setNewCategoryPic(null);
              }}
              className="w-full sm:w-auto px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
            >
              {translations.category.cancel}
            </button>

            <button
              onClick={handleUpdateService}
              disabled={
                newCategoryDesc.length > 0 && newCategoryDesc.length < 50
              }
              className={`w-full sm:w-auto px-4 py-2 rounded text-white ${
                newCategoryDesc.length > 0 && newCategoryDesc.length < 50
                  ? "bg-blue-300 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {translations.category.update}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Services;
